import axios from "axios";
// import { useSelector } from "react-redux";

const axiosinstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    'Content-Type': 'application/json'
});

axiosinstance.interceptors.request.use(
    (config) => {
        // const { user } = useSelector((state) => (state.user));
        // const token = user.token;
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.authtoken = `Bearer ${token}`;
            //config.headers.Authorization = `Bearer ${token}`;
        }

        // console.log('axiosinstance ---> ', token);
        return config;
    },
    (error) => Promise.reject(error)
);

export { axiosinstance };



/*const token = localStorage.getItem('token');

console.log('axiosconfig ---> token : ', token);

const axiosinstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: { 'Authorization': `Bearer ${token}` }
});

export { axiosinstance };*/